import { render, staticRenderFns } from "./languages.vue?vue&type=template&id=0f697804&"
import script from "./languages.vue?vue&type=script&lang=js&"
export * from "./languages.vue?vue&type=script&lang=js&"
import style0 from "./languages.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../dates/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports